import { Button, ButtonModes } from "./Button";

interface RedirectionBoxProps {
  cta: string,
  url: string,
  title?: string,
  description: string,
  newWindow?: boolean,
}

export const RedirectionBox = (props: RedirectionBoxProps) => (
  <div className="redirection-box">
    <div className="redirection-box__content">
      <div className="redirection-box__text-container">
        {props.title && <div className="redirection-box__title">{props.title}</div>}
        <div className="redirection-box__text">{props.description}</div>
      </div>
      <div className="redirection-box__button">
        <Button
          color="var(--color-razem-600)"
          mode={ButtonModes.secondary}
          url={props.url}
          newWindow={props.newWindow}
        >
          {props.cta}
        </Button>
      </div>
    </div>

  </div>
);